module.exports = __webpack_public_path__ + "img/538838dbeb1a3bd5981074db4fcb03e7.bc314dc9.jpg";